import { Navigate, useLocation } from 'react-router-dom';

export const AttorneyRouteBoundary = ({ user, children }) => {
  const { pathname } = useLocation();
  if (user?.role !== 'attorney') return children;
  if (pathname === '/settings') return <Navigate to="/my-settings" replace />;
  if (!['/', '/login', '/lawsuits', '/my-settings', '/pulse-planner', '/team-tasks'].includes(pathname.replace(/\/$/, '') || '/')) {
    return <Navigate to="/" replace />;
  }
  return children;
};